// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Question_Controls__2I0H7"};